import { createSlice } from "@reduxjs/toolkit";
import { getWindow } from "ssr-window";

import utilsConfig from "@/utils/config";
import { modeEnum, reportTypeEnum } from "@/utils/enum";
import { getToken } from "@/utils/cookies";

export const config = createSlice({
  name: "config",
  initialState: {
    // ナビゲータのタイトル
    navigationTitle: "Trynibus",
    // spナビゲータのタイトル
    navigationMobileTitle: "Trynibus",
    // 現在のページのルート
    configRouter: undefined,
    // アクセスモード
    mode: modeEnum.normal,
    // auth0 appState
    appState: undefined,
  },
  reducers: {
    // 現在のページのルートを更新します
    updateRouter: (state, action) => {
      const to = utilsConfig.getRouterByPath(action?.payload?.path);
      if (state.configRouter !== to) {
        let title;
        if (
          (to?.reportType === reportTypeEnum.research ||
            to?.reportType === reportTypeEnum.library ||
            to?.reportType === reportTypeEnum.LPNews ||
            to?.reportType === reportTypeEnum.information) &&
          action?.payload?.title &&
          to?.title
        ) {
          title = `${action?.payload?.title}${to?.title}`;
        } else {
          title = to?.title;
        }
        state.configRouter = to;
        state.navigationTitle = title || "Trynibus";
        state.navigationMobileTitle = to?.mobileTitle || "Trynibus";
      }
    },

    // windowの情報を更新します
    updateWindow: (state, action) => {
      const ssrWindow = getWindow();
      if (!ssrWindow.sitecoreExternal) {
        ssrWindow.sitecoreExternal = {};
      }
      if (!ssrWindow.sitecoreExternal.user) {
        ssrWindow.sitecoreExternal.user = {};
      }
      if (!ssrWindow.sitecoreExternal.router) {
        ssrWindow.sitecoreExternal.router = {};
      }
      const authentication = action?.payload?.authentication
        ? action?.payload?.authentication
        : getToken();
      if (authentication) {
        ssrWindow.sitecoreExternal.user = {
          accountId: authentication?.accountId,
          accessToken: authentication?.token,
        };
      }
      if (action?.payload?.history) {
        ssrWindow.sitecoreExternal.router = {
          history: action?.payload?.history,
        };
      }
    },

    // ナビゲータのタイトルの更新
    updateNavigationTitle: (state, action) => {
      state.navigationTitle = action?.payload?.navigationTitle;
    },

    // spナビゲータのタイトルの更新
    updateNavigationMobileTitle: (state, action) => {
      state.navigationMobileTitle = action?.payload?.navigationMobileTitle;
    },

    // アクセスモードの更新
    updateMode: (state, action) => {
      state.mode = action?.payload?.mode;
    },

    // auth0 appStateの更新
    updateAppState: (state, action) => {
      state.appState = action?.payload?.appState;
    },
  },
});

export const {
  updateRouter,
  updateWindow,
  updateMode,
  updateAppState,
  updateNavigationTitle,
  updateNavigationMobileTitle,
} = config.actions;

export const navigationTitle = (state) => state.config.navigationTitle;

export const navigationMobileTitle = (state) =>
  state.config.navigationMobileTitle;

export const router = (state) => state.config.configRouter;

export const mode = (state) => state.config.mode;

export default config.reducer;
